import { Descendant, Editor, Node } from 'slate';

export function isAncestorEmpty(editor: Editor, node: Descendant) {
    return !Node.string(node) && !node.children.some((n) => Editor.isInline(editor, n));
}
